import { SourceConfig, GameConfig } from '../types'

export const SOURCES: Record<string, SourceConfig> = {
  official_cn: {
    name: '米哈游官网',
    nameEn: 'HoYoverse Official (CN)',
    icon: '🌐',
    color: '#4FC3F7',
    baseUrl: 'https://www.mihoyo.com'
  },
  official_en: {
    name: 'HoYoverse Official',
    nameEn: 'HoYoverse Official (EN)',
    icon: '🌐',
    color: '#4FC3F7',
    baseUrl: 'https://www.hoyoverse.com'
  },
  weibo: {
    name: '微博',
    nameEn: 'Weibo',
    icon: '📱',
    color: '#E6162D',
    baseUrl: 'https://weibo.com'
  },
  weibo_legal: {
    name: '米哈游法务部',
    nameEn: 'miHoYo Legal',
    icon: '⚖️',
    color: '#FFA726',
    baseUrl: 'https://weibo.com'
  },
  bilibili: {
    name: 'B站',
    nameEn: 'Bilibili',
    icon: '📺',
    color: '#00A1D6',
    baseUrl: 'https://www.bilibili.com'
  },
  twitter: {
    name: 'Twitter/X',
    nameEn: 'Twitter/X',
    icon: '🐦',
    color: '#1DA1F2',
    baseUrl: 'https://twitter.com'
  },
  youtube: {
    name: 'YouTube',
    nameEn: 'YouTube',
    icon: '▶️',
    color: '#FF0000',
    baseUrl: 'https://www.youtube.com'
  },
  reddit: {
    name: 'Reddit',
    nameEn: 'Reddit',
    icon: '💬',
    color: '#FF4500',
    baseUrl: 'https://www.reddit.com'
  }
}

export const GAMES: Record<string, GameConfig> = {
  genshin: {
    name: '原神',
    nameEn: 'Genshin Impact',
    icon: '⚔️',
    color: '#00D4FF'
  },
  starrail: {
    name: '崩坏：星穹铁道',
    nameEn: 'Honkai: Star Rail',
    icon: '🚂',
    color: '#FFD700'
  },
  zzz: {
    name: '绝区零',
    nameEn: 'Zenless Zone Zero',
    icon: '🌆',
    color: '#FF6B9D'
  },
  honkai3: {
    name: '崩坏3',
    nameEn: 'Honkai Impact 3rd',
    icon: '💥',
    color: '#9C27B0'
  },
  tears: {
    name: '未定事件簿',
    nameEn: 'Tears of Themis',
    icon: '📜',
    color: '#E91E63'
  },
  legal: {
    name: '米哈游法务部',
    nameEn: 'miHoYo Legal',
    icon: '⚖️',
    color: '#FFA726'
  }
}

export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'
